// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"4f86e3c5f4053f4bde2e","522":"2baae9e4ef57b0de62bd"}[chunkId] + ".js";
};